'use strict';

/**
 * Exports
 * @param {string} filename
 * @returns {Object}
 */
module.exports = function (filename) {
  var parts = filename.split('.');
  parts.pop();
  var name = parts.join('.');

  return {
    src: filename,
    meta: name + '.meta.json',
    original: name + '.original',
    inspect: name + '.inspect.json'
  };
};


//////////////////
// WEBPACK FOOTER
// ../lib/filenames.js
// module id = 493
// module chunks = 0